<script lang="ts" setup>
import { getOtherRecipes } from '#imports'
import { setIsPraatjePot } from '~/utils/registration'

definePageMeta({
  layout: false
})

defineRouteRules({
  prerender: true
})

const otherRecipes = getOtherRecipes()
const otherMatchStories = await useRandomMatchStories()
</script>

<template>
  <SEOPageLayout seo-key="weekmenu-gezond">
    <template #description>
      <VI18n key-path=".description" class="text-lg">
        <template #link1>
          <VLink label=".link-one" :to="{ name: 'gezond-avondeten' }" />
        </template>
        <template #link2>
          <VLink label=".link-two" :to="{ name: 'gezonde-avondmaaltijd' }" />
        </template>
      </VI18n>
    </template>

    <template #buttons>
      <VButton
        :to="{ name: 'registreren-maaltijdzoeker' }"
        label="buttons.foodie"
        @click="setIsPraatjePot"
      />
    </template>

    <VSection title=".paragraph-one.title">
      <VI18n key-path=".paragraph-one.content">
        <template #link1>
          <VLink label=".paragraph-one.link-one" :to="{ name: 'maaltijdservice' }" />
        </template>
        <template #link2>
          <VLink
            label=".paragraph-one.link-two"
            :to="{ name: 'gezonde-avondmaaltijd' }"
          />
        </template>
      </VI18n>
    </VSection>

    <BlogPostsSection title="titles.recipes" :blog-posts="otherRecipes" />

    <VSection title=".paragraph-two.title">
      <VI18n key-path=".paragraph-two.content">
        <template #link1>
          <VLink label=".paragraph-two.link-one" :to="{ name: 'thuiskok' }" />
        </template>
      </VI18n>
    </VSection>

    <ListSection />

    <VSection title=".paragraph-three.title">
      <VI18n key-path=".paragraph-three.content">
        <template #link1>
          <VLink label=".paragraph-three.link-one" :to="{ name: 'maaltijdbezorging' }" />
        </template>
      </VI18n>

      <template #after>
        <div class="section-button">
          <VButton
            :to="{ name: 'registreren-maaltijdzoeker' }"
            label="buttons.foodie"
            @click="setIsPraatjePot"
          />
        </div>
      </template>
    </VSection>

    <BlogPostsSection title="titles.match-stories" :blog-posts="otherMatchStories" />
  </SEOPageLayout>
</template>

<style scoped></style>
